import WhitelistsContext from '../contexts/WhitelistsContext';
import { useContext } from 'react';

const useWhitelists = () => useContext(WhitelistsContext);

export default useWhitelists;
